import http from "../http-common";

class ProjectDataService {
  getAll() {
    return http.get("/projects");
  }

  get(id) {
    return http.get(`/projects/${id}`);
  }

  getByUser() {
    return http.get("/projects/byUser");
  }

  create(data) {
    return http.post("/projects", data);
  }

  update(id, data) {
    return http.put(`/projects/${id}`, data);
  }

  insertFile(id, data) {
    return http.put(`/projects/file-insert/${id}`, data);
  }

  updateFile(id, fileId, data) {
    return http.put(`/projects/file-update/${id}/${fileId}`, data);
  }

  delete(id) {
    return http.delete(`/projects/${id}`);
  }

  deleteAll() {
    return http.delete(`/projects`);
  }

  findByTitle(title) {
    return http.get(`/projects?title=${title}`);
  }

  cloneProject(data) {
    return http.post("/projects/clone", data);
  }

  createtable(data) {
    return http.post("/projects/createdbtables", data);
  }

  updatetable(id, data) {
    return http.put(`/projects/${id}/createdbtables`, data);
  }
}

export default new ProjectDataService();
